import { MicrositeTemplate } from '~/model';
import { type ComponentConfig } from '@puckeditor/core';
import PoweredBlockAlpha from '~/editor/templates/alpha/PoweredBlockAlpha';
import PoweredBlockDelta from '~/editor/templates/delta/PoweredBlockDelta';
import PoweredBlockEpsilon from '~/editor/templates/epsilon/PoweredBlockEpsilon';
import PoweredBlockEta from '~/editor/templates/eta/PoweredBlockEta';
import PoweredBlockZeta from '~/editor/templates/zeta/PoweredBlockZeta';
import PoweredBlockBeta from '~/editor/templates/beta/PoweredBlockBeta';

export interface PoweredBlockProps {
	template: MicrositeTemplate;
}

export const PUCK_BLOCK_POWERED: ComponentConfig<PoweredBlockProps> = {
	label: 'Powered',
	fields: {
		template: {
			type: 'radio',
			options: [
				{ label: 'Alpha', value: MicrositeTemplate.ALPHA },
				{ label: 'Beta', value: MicrositeTemplate.BETA },
				{ label: 'Delta', value: MicrositeTemplate.DELTA },
				{ label: 'Epsilon', value: MicrositeTemplate.EPSILON },
				{ label: 'Eta', value: MicrositeTemplate.ETA },
				{ label: 'Zeta', value: MicrositeTemplate.ZETA },
			],
		},
	},
	defaultProps: {
		template: MicrositeTemplate.ETA,
	},
	permissions: {
		duplicate: false,
	},
	render(props) {
		return <PoweredBlock {...props} />;
	},
};

export default function PoweredBlock({ template }: PoweredBlockProps) {
	if (template === MicrositeTemplate.ALPHA) {
		return <PoweredBlockAlpha tenantLogo="https://media.photology.co/tenant/twt/logo.svg" />;
	}
	if (template === MicrositeTemplate.BETA) {
		return <PoweredBlockBeta logo="https://media.photology.co/tenant/twt/logo.svg" legal="331 Enterprises, LLC" />;
	}
	if (template === MicrositeTemplate.DELTA) {
		return <PoweredBlockDelta tenantLogo="https://media.photology.co/tenant/twt/logo.svg" />;
	}
	if (template === MicrositeTemplate.EPSILON) {
		return <PoweredBlockEpsilon tenantLogo="https://media.photology.co/tenant/twt/logo.svg" />;
	}
	if (template === MicrositeTemplate.ETA) {
		return <PoweredBlockEta tenantLogo="https://media.photology.co/tenant/twt/logo.svg" />;
	}
	if (template === MicrositeTemplate.ZETA) {
		return <PoweredBlockZeta tenantLogo="https://media.photology.co/tenant/twt/logo.svg" />;
	}

	return <></>;
}
